export const units = [
  {
    title: 'Self Awareness',
    color: '#f15e4a',
    idStub: 'hsidentity',
  },
  {
    title: 'Stress and Regulation',
    color: '#f48955',
    idStub: 'hsstress',
  },
  {
    title: 'Decision Making Skills',
    color: '#fdd209',
    idStub: 'hsdecision',
  },
  {
    title: 'Belonging and Peer Influence',
    color: '#58c3bb',
    idStub: 'hsbelonging',
  },
  {
    title: 'Empathy and Conflict Resolution',
    color: '#09aedb',
    idStub: 'hsempathy',
  },
];

export const getStrengthsModuleIds = () => {
  return [
    'hsbelonging-self-assessment',
    'hsdecision-self-assessment',
    'hsidentity-self-assessment',
    'hsstress-self-assessment',
    'hsbelonging-self-assessment-mena',
    'hsempathy-self-assessment',
    'hsidentity-self-assessment-standard',
    'hsstress-self-assessment-mena',
  ];
};

// Languages each strengths module has content in (packages/content-meta). The MENA
// variants have no Spanish content and most standard modules have no Arabic.
const STRENGTHS_MODULE_LANGUAGES: Record<string, string[]> = {
  'hsbelonging-self-assessment': ['en', 'es'],
  'hsdecision-self-assessment': ['en', 'es', 'ar'],
  'hsidentity-self-assessment': ['en', 'es'],
  'hsstress-self-assessment': ['en', 'es'],
  'hsbelonging-self-assessment-mena': ['en', 'ar'],
  'hsempathy-self-assessment': ['en', 'es', 'ar'],
  'hsidentity-self-assessment-standard': ['en', 'es', 'ar'],
  'hsstress-self-assessment-mena': ['en', 'ar'],
};

// The language to load a strengths module in: the requested language when the
// module has it, otherwise English. Unknown modules keep the requested language.
export const getStrengthsModuleLanguage = (moduleId: string, language: string): string => {
  const languages = STRENGTHS_MODULE_LANGUAGES[moduleId];
  return !languages || languages.includes(language) ? language : 'en';
};

export const getOuterSlicePath = (
  centreX: number,
  centreY: number,
  startAngleRadians: number,
  sweepAngleRadians: number,
  radius: number,
) => {
  const startX = centreX + radius * Math.cos(startAngleRadians);
  const startY = centreY + radius * Math.sin(startAngleRadians);
  const firstArcEndX = centreX + radius * Math.cos(startAngleRadians + sweepAngleRadians);
  const firstArcEndY = centreY + radius * Math.sin(startAngleRadians + sweepAngleRadians);
  const lineEndX = firstArcEndX + radius * 2.5 * Math.cos(startAngleRadians + sweepAngleRadians);
  const lineEndY = firstArcEndY + radius * 2.5 * Math.sin(startAngleRadians + sweepAngleRadians);
  const secondArcEndX = startX + radius * 2.5 * Math.cos(startAngleRadians);
  const secondArcEndY = startY + radius * 2.5 * Math.sin(startAngleRadians);

  return `M${startX},${startY} A${radius},${radius} 0 0,1 ${firstArcEndX},${firstArcEndY}, L${lineEndX},${lineEndY}, A${
    radius * 3.5
  },${radius * 3.5} 0 0,0 ${secondArcEndX},${secondArcEndY} Z`;
};

export const getOuterTextCoordinates = (
  centreX: number,
  centreY: number,
  startAngleRadians: number,
  sweepAngleRadians: number,
  radius: number,
) => {
  const secondCircumferenceX = centreX + radius * Math.cos(startAngleRadians + sweepAngleRadians * 0.5) + 30;
  const secondCircumferenceY = centreY + radius * Math.sin(startAngleRadians + sweepAngleRadians * 0.5) - 70;

  return [secondCircumferenceX, secondCircumferenceY];
};
